import React, { useState, useCallback, useMemo } from 'react';
import { Button, Form, FormControl } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import { StateSelect } from '../../util';
import claimContractorsService from '../../services/claim/claim_contractors.service';
export function ContractorsRow(_ref) {
  let {
    showTypeAndYear = false,
    index,
    claim,
    handleDelete,
    claimContractors,
    setClaimContractors,
    refreshClaim,
    handleError
  } = _ref;
  const [hasError, setHasError] = useState(false);
  const claimContractor = useMemo(() => {
    return {
      ...claimContractors[index]
    };
  }, [claimContractors, index]);
  const dispatch = useDispatch();
  const updateContractors = useCallback(subcontractor => {
    const newContractors = [...claimContractors];
    newContractors[index] = {
      ...subcontractor
    };
    setClaimContractors([...newContractors]);
  }, [claimContractors, index, setClaimContractors]);
  const handleChange = useCallback(event => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    claimContractor[event.target.name] = value;
    updateContractors(claimContractor);
  }, [updateContractors, claimContractor]);
  const saveChange = useCallback(() => {
    let method;
    if (claimContractor.id) {
      method = 'update';
    } else {
      method = 'create';
    }
    claimContractorsService[method](claimContractor).then(updatedSubcontractor => {
      setHasError(false);
      updateContractors(updatedSubcontractor);
      refreshClaim();
    }).catch(e => {
      setHasError(true);
      dispatch(handleError(e));
    });
  }, [updateContractors, claimContractor, dispatch, refreshClaim]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: hasError ? 'bg-warning' : ''
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked,
    name: "name",
    object: {
      ...claimContractor,
      claim: {
        ...claim,
        ...claimContractor.claim
      }
    },
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: "textarea",
    onChange: handleChange,
    onBlur: saveChange,
    name: "services_provided",
    object: {
      ...claimContractor,
      claim: {
        ...claim,
        ...claimContractor.claim
      }
    },
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: StateSelect,
    state: claimContractor.state,
    onChange: e => {
      handleChange(e);
      saveChange();
    },
    disabled: claim.financials_locked,
    name: "state",
    object: {
      ...claimContractor,
      claim: {
        ...claim,
        ...claimContractor.claim
      }
    },
    size: "sm",
    type: "text"
  })), showTypeAndYear && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormControl, {
    disabled: true,
    name: "type",
    type: "text",
    size: "sm",
    value: claimContractor.claim.id_in_provider_system ? 'Claim' : 'Base'
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormControl, {
    disabled: true,
    name: "type",
    type: "text",
    size: "sm",
    value: claimContractor.claim.label
  }))), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked,
    name: "expense",
    object: {
      ...claimContractor,
      claim: {
        ...claim,
        ...claimContractor.claim
      }
    },
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked,
    name: "rnd_apportionment",
    object: {
      ...claimContractor,
      claim: {
        ...claim,
        ...claimContractor.claim
      }
    },
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    disabled: true,
    name: "qre",
    object: {
      ...claimContractor,
      claim: {
        ...claim,
        ...claimContractor.claim
      }
    },
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    variant: "secondary",
    disabled: claim.is_locked || claim.financials_locked || claim.active_change_set,
    style: {
      height: '28px'
    },
    onClick: handleDelete
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons text-danger"
  }, "delete")))));
}